import React from "react";

import Str from "shared/components/Str";
import {
	APPLE_LINK,
	ANDROID_LINK,
} from "shared/dictionaries/app_store_campaigns.js";

import "./index.scss";

if (process.env.PLATFORM === "mobile") {
	require("./index.mobile.scss");
} else {
	require("./index.desktop.scss");
}

const FooterAppCTA = () => {
	return (
		<div id="footer-cta-container">
			<div className="footer-cta">
				<div className="footer-cta-illustration" />
				<div className="footer-cta-copy">
					<h4 className="footer-cta-copy-title">
						<Str>Download the OkCupid app</Str>
					</h4>
					<Str className="footer-cta-copy-subtitle">Discover people on the go.</Str>
				</div>
				<div className="footer-cta-links">
					<a
						href={APPLE_LINK("footer_cta")}
						className="footer-cta-links-link apple"
					>
						<Str>App Store</Str>
					</a>
					<a
						href={ANDROID_LINK("footer_cta")}
						className="footer-cta-links-link google"
					>
						<Str>Google Play</Str>
					</a>
				</div>
			</div>
		</div>
	);
};

export default FooterAppCTA;



// WEBPACK FOOTER //
// ./src/shared/components/FooterAppCTA/index.jsx